import axiosInstance from "./axiosInstance";

export const generatePdf = async (
  htmlContent: string,
  {
    title,
    version,
    publishedOn,
  }: { title: string; version: string; publishedOn: string }
) => {
  try {
    const response = await axiosInstance.post(
      `/document/generate-pdf/${title}/${version}/${publishedOn}`,
      htmlContent,
      {
        headers: {
          "Content-Type": "text/html",
        },
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${title}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
};
